import React from 'react'
import numeral from 'numeral'

import { useLocation, useHistory } from 'react-router-dom'
import { addToQuerystring } from '../../../utils/querystring'

import KeyMetricsWidget from '../components/KeyMetricsWidget'
import withFetch from '../../../infrastructure/withFetch'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'

import TagValueChart from './TagValueChart'

const Page = ({ status, data, retry, tagKeyName }) => {
    const location = useLocation()
    const history = useHistory()

    const anyResults = data.total !== 0
    const tagKeys = data.tagKeys || []

    const tagKeyToggle = (
        <div className="btn-group">
            {tagKeys.map(tagKey => (
                <button
                    key={tagKey.tagKeyId}
                    className={`btn btn-xs ${
                        tagKey.tagKeyName === tagKeyName
                            ? 'btn-primary'
                            : 'btn-white'
                    }`}
                    type="button"
                    onClick={() => setTagKey(tagKey.tagKeyName)}
                >
                    {tagKey.tagKeyName}
                </button>
            ))}
        </div>
    )

    const setTagKey = tagKeyName => {
        history.push(
            addToQuerystring(location, {
                tagKey: tagKeyName,
            }),
        )
    }

    const tools = <>{tagKeyToggle}</>

    return (
        <>
            <div className="row">
                <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12">
                    <Subtitle title="Summary" tools={tools} />
                    <KeyMetricsWidget data={data} status={status} retry={retry}>
                        {!anyResults && (
                            <Box>
                                <div>No result(s)</div>
                            </Box>
                        )}

                        {anyResults && (
                            <>
                                <div className="key-metrics ibox">
                                    <div className="key-metrics-items">
                                        <div className="key-metric-item active">
                                            <div className="key-title">
                                                Tickets Issued
                                            </div>
                                            <div className="key-value">
                                                <span>
                                                    {numeral(data.total).format(
                                                        '0,0',
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="key-metric-chart disable-click-md"
                                        style={{
                                            userSelect: 'none',
                                            paddingBottom: 30,
                                        }}
                                    >
                                        <TagValueChart data={data} />
                                    </div>
                                </div>
                            </>
                        )}
                    </KeyMetricsWidget>
                </div>
            </div>
        </>
    )
}

const Fetch = withFetch(
    ({ eventId, startDate, endDate, tagKeyName }) =>
        `/api/tickets-issued/get-tickets-issued-pivoted-by-tag-value/${eventId}?startDate=${startDate}&endDate=${endDate}&tagKey=${tagKeyName}`,
    fetchProps => <Page {...fetchProps} />,
)

export default props => <Fetch {...props} />
